var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampfire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.574 14.295S5.325 12.957 8.022 7.5c0 0 1.109 2.08 2.806 2.476 0 0-2.653-4.216 1.832-6.976 0 0-1.08 4.738 1.985 5.922 0 0 .848-.498.412-2.284 0 0 4.027 4.132-1.148 7.56M5.506 14.23a1.152 1.152 0 0 0-1.45.755 1.152 1.152 0 0 0 .754 1.45l3.148.995 4.04-1.145-6.492-2.055ZM19.2 18.55l-3.148-.996-4.04 1.145 6.486 2.055a1.152 1.152 0 0 0 1.45-.754 1.156 1.156 0 0 0-.748-1.45ZM16.052 17.554l3.174-.897a1.154 1.154 0 0 0-.631-2.218l-6.544 1.854",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.019 17.43-3.18.904a1.154 1.154 0 0 0 .63 2.218l6.544-1.853",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfire);
export default __webpack_public_path__ + "static/media/campfire.5993ee4f.svg";
export { ForwardRef as ReactComponent };